import type { Dispatch, ReducersMapObject, Store } from "redux";
import { type TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";
import type { CommonReducerType, CommonActionsType } from "../../../../common-deprecated/redux/commonStore";
import utilReducer from "../../../../common-deprecated/redux/reducers/UtilReducer";
import { getInitStoreByReducers } from "../../../../common-deprecated/redux/storeHelpers";
import commonUtilLogic from "../../../../common-deprecated/redux/logic/CommonUtilLogic";
import type { CreateLogicType } from "../../../../common-deprecated/redux/typeHelpers";
import modalReducer from "../../../../common-deprecated/redux/reducers/ModalReducer";
import equipmentReducer, { type EquipmentReducerType } from "./reducers/EquipmentReducer";
import CommonSettingsReducer from "../../../../common-deprecated/redux/reducers/CommonSettingsReducer";
import type { EquipmentActionsType } from "./actions/EquipmentActions";
import EquipmentV2SettingsReducer, { type EquipmentV2SettingsType } from "./reducers/EquipmentV2SettingsReducer";
import type { EquipmentV2SettingsActionsType } from "./actions/EquipmentV2SettingsActions";
import EquipmentFinanceReducer, { type EquipmentV2FinanceRateStateType } from "./reducers/EquipmentFinanceReducer";
import type { EquipmentV2FinanceActionsType } from "./actions/EquipmentFinanceActions";
import financeLogic from "../logic/financeLogic";

export type EquipmentV2StateType = CommonReducerType & {
    equipment: EquipmentReducerType;
    equipmentV2Settings: EquipmentV2SettingsType;
    finance: EquipmentV2FinanceRateStateType;
};

export type EquipmentV2AllActionsType =
    | CommonActionsType
    | EquipmentActionsType
    | EquipmentV2SettingsActionsType
    | EquipmentV2FinanceActionsType;

export type EquipmentV2DispatchType = Dispatch<EquipmentV2AllActionsType>;

export type EquipmentV2LogicType<ActionsType extends EquipmentV2AllActionsType> = CreateLogicType<
    ActionsType,
    EquipmentV2StateType,
    EquipmentV2DispatchType
>;

export type EquipmentV2StoreType = Store<EquipmentV2StateType, EquipmentV2AllActionsType>;

export const useEquipmentV2Dispatch = useDispatch<EquipmentV2DispatchType>;

export const useEquipmentV2Selector: TypedUseSelectorHook<EquipmentV2StateType> = useSelector;

const equipmentComponentLogic = [...commonUtilLogic, ...financeLogic];

const equipmentReducers: ReducersMapObject<EquipmentV2StateType, any> = {
    equipment: equipmentReducer,
    equipmentV2Settings: EquipmentV2SettingsReducer,
    commonSettings: CommonSettingsReducer,
    finance: EquipmentFinanceReducer,
    modal: modalReducer,
    utils: utilReducer,
};

export const equipmentV2ClientStore = getInitStoreByReducers(equipmentReducers, equipmentComponentLogic);
export const equipmentV2ServerStore = getInitStoreByReducers(equipmentReducers);
